import o,{Component as e}from"react";import t from"styled-components";import n from"prop-types";import{calculateRem as a}from"@vds-core/utilities";import{Fonts as i}from"@vds-core/typography";import{AccessibilityTokens as r}from"@vds-tokens/accessibility";import{TypographyTokens as l}from"@vds-tokens/typography";const c=t.label.withConfig({displayName:"StyledLabel",componentId:"VDS__sc-1bjel3a-0"})`
  display: inline-flex;
  border-radius: 1rem;
  height: ${({toggleHeight:o})=>a(o)};
  width: ${a(52)};
  overflow: hidden;
  ${({disabled:o,surface:e,keyboardFocused:t})=>!o&&t&&`\n    &:not(:hover) {\n      outline: none;\n      &::before {\n        border: ${a(r.focusring.borderwidth.value)} ${r.focusring.borderstyle.value} ${"dark"===e?r.color.focusring.ondark.value:r.color.focusring.onlight.value};\n        border-radius: 1rem;\n        content: '';\n        height: calc(100% + ${a(4)});\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: calc(100% + ${a(4)});\n      }\n    }\n    `}
`,s=t.span.withConfig({displayName:"ToggleSwitchSlider",componentId:"VDS__sc-1bjel3a-1"})`
  border-radius: 1rem;
  border: ${a(2)} solid transparent;
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  cursor: ${({disabled:o})=>o?null:"pointer"};
  background-color: ${({calculateBackgroundColor:o,disabled:e,on:t,surface:n,textPosition:a})=>o(e,t,n)};
  color: ${({calculateTextColor:o,disabled:e,surface:t,textPosition:n})=>o(e,t,n)};
  height: ${({toggleHeight:o})=>a(o)};
  transition: background-color 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  width: ${a(52)};
  &::before {
    background-color: ${({calculateButtonColor:o,disabled:e,surface:t})=>o(e,t)};
    border-radius: 50%;
    bottom: 0;
    content: '';
    height: ${({knobSize:o})=>a(o)};
    left: 0;
    margin-bottom: auto;
    margin-top: auto;
    padding-left: 0;
    position: absolute;
    top: 0;
    transition: left 100ms;
    width: ${({knobSize:o})=>a(o)};
    z-index: 1;
    box-shadow: ${({calculateDropShadow:o,disabled:e})=>o(e)};
    };
    
  }

  &:active,
  &:focus {
    outline: none;
  }

  ${({showText:o,textPosition:e})=>o&&"center"===e&&`\n    &::after {\n      content: 'Off';\n      font-size: ${a(l.fontsize.body[12].value)};\n      line-height: ${a(l.lineheight.body[16].value)};\n      font-weight: ${l.fontweight.bold.value};\n      font-family: ${i.VerizonNHGeTX};\n      position: absolute;\n      right: ${a(4)};\n      top: ${a(3)};\n      z-index: 0;\n    }\n\n  `};

  ${({on:o,knobLeftPosition:e,disabled:t})=>o&&`\n    transition: background-color 100ms;\n    transition-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1.0);\n    &::before {\n      content: '';\n      left: ${a(e)} !important; \n      transition: left 100ms; \n    }\n  `};

  ${({showText:o,on:e,calculateTextColor:t,disabled:n,surface:i,textPosition:r})=>e&&o&&"center"===r&&`\n    &::after {\n      color: ${t(n,i)};\n      content: 'On';\n      right: ${a(24)};\n      top: ${a(3)};\n      z-index: 0;\n    }\n  `};
`,d=t.input.withConfig({displayName:"ToggleInput",componentId:"VDS__sc-1bjel3a-2"})`
  opacity: 0;
  margin: 0;
  width: 2rem;
  height: 1rem;
  position: absolute;
  top: 0;
  pointer-events: auto;
  &:hover {
    cursor: pointer;
  }
`,u={on:n.bool,disabled:n.bool,onClick:n.func,onKeyPress:n.func,onChange:n.func,name:n.string,calculateTextColor:n.func,calculateBackgroundColor:n.func,calculateButtonColor:n.func,tabIndex:n.number};class b extends e{constructor(){super(...arguments),this.state={keyboardFocused:!1},this._onFocus=()=>{this.setState({keyboardFocused:!0})},this._onBlur=()=>{this.setState({keyboardFocused:!1})}}render(){const{on:e,disabled:t,onKeyDown:n,handleSwitchClick:a,onChange:i,tabIndex:r,name:l,value:u,calculateTextColor:b,calculateBackgroundColor:g,calculateButtonColor:h,calculateDropShadow:f,analyticsTrack:p,track:m,trackIgnore:k,clickStream:y,surface:$,inputId:x,focusId:w,textPosition:C,showText:v,ariaLabel:S,toggleHeight:T,knobSize:z,knobLeftPosition:P}=this.props;let B=e;return o.createElement(c,{id:w,disabled:t,surface:$,htmlFor:x||(l||"toggle"),keyboardFocused:this.state.keyboardFocused,toggleHeight:T},o.createElement(d,{"data-testid":"test-toggle","aria-label":S||l,type:"checkbox",disabled:t,checked:B,name:l,value:u,id:x||(l||"toggle"),tabIndex:r,"data-analyticstrack":p,"data-track":m,"data-track-ignore":k,"data-clickstream":y,onFocus:this._onFocus,onBlur:this._onBlur,onChange:i,onKeyDown:n,onClick:o=>a(o)}),o.createElement(s,{tabIndex:-1,"aria-hidden":!0,surface:$,disabled:t,on:+B,calculateTextColor:b,calculateBackgroundColor:g,calculateButtonColor:h,calculateDropShadow:f,textPosition:C,showText:v,toggleHeight:T,knobSize:z,knobLeftPosition:P}))}}b.propTypes=u,b.defaultProps={on:!1,disabled:!1,onClick:()=>{},onKeyPress:()=>{},onChange:()=>{},name:null};export{b as default};
